import React, { useCallback } from 'react';
import { USER_SIZE_UNIT_INCH } from '@/constants';
import { getDisplayedSizeValueByUnit, getCalcSizeValueByUnit } from '@/helpers';
import UsefullNumericInput from './UsefullNumericInput';

const UsefullNumericSizeInput = (props) => {
  const {
    onChange,
    value,
    minval,
    stepMm,
    units,
    ...restProps
  } = props;

  const onChangeClb = useCallback(newVal => {
    onChange(getCalcSizeValueByUnit(newVal, units));
  },[units]);

  return (
    <UsefullNumericInput
      {...restProps}
      onChange={onChangeClb}
      value={getDisplayedSizeValueByUnit(value, units)}
      step={units === USER_SIZE_UNIT_INCH ? (stepMm / 20) : stepMm}
      minval={getDisplayedSizeValueByUnit(minval, units)}
    />
  )
};

export default React.memo(UsefullNumericSizeInput);
